module.exports = __webpack_public_path__ + "img/9791187038191.252025bf.jpg";